export default {
  title: 'Solicitar eliminación de datos de {{name}}',
  description:
    'Esto crea una solicitud de eliminación de datos RGPD. Un administrador debe aprobarla antes de que los datos del cliente se eliminen permanentemente.',
  form: {
    note: {
      label: 'Nota',
      placeholder: 'Añade contexto para esta solicitud (opcional)',
    },
  },
  buttons: {
    confirm: 'Solicitar eliminación',
  },
  toasts: {
    success: 'Solicitud de eliminación de datos creada',
    error: 'Error al crear la solicitud de eliminación de datos',
  },
};
